export default __webpack_public_path__ + "static/media/logo-firefox.c12ecb5e.svg";